import React from 'react'
import { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

interface StatsCardProps {
 title: string
 value: number | string
 icon: LucideIcon
 iconColor?: string
 iconBg?: string
 trend?: {
 value: number
 isPositive: boolean
 }
 className?: string
}

export const StatsCard: React.FC<StatsCardProps> = ({
 title,
 value,
 icon: Icon,
 iconColor = 'text-accent',
 iconBg = 'bg-accent/10',
 trend,
 className,
}) => {
 return (
 <div className={cn('bg-card border border-border rounded-lg p-4 shadow-precision', className)}>
 <div className="flex items-center justify-between mb-3">
 <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground truncate pr-2">
 {title}
 </p>
 <div className={cn('p-1.5 rounded-md flex-shrink-0', iconBg)}>
 <Icon className={cn('h-3.5 w-3.5', iconColor)} />
 </div>
 </div>
 <div className="flex items-end justify-between gap-2">
 <p
 className="text-2xl font-semibold text-foreground tabular-nums"
 style={{ fontFamily: '"JetBrains Mono", monospace' }}
 >
 {value}
 </p>
 {trend && (
 <span
 className={cn(
 'text-xs font-semibold px-1.5 py-0.5 rounded mb-0.5',
 trend.isPositive
 ? 'text-emerald-700 bg-emerald-50 dark:text-emerald-400 dark:bg-emerald-900/20'
 : 'text-red-700 bg-red-50 dark:text-red-400 dark:bg-red-900/20',
 )}
 >
 {trend.isPositive ? '+' : ''}
 {trend.value}%
 </span>
 )}
 </div>
 </div>
 )
}
